/**
 * Chain Configurator
 * Verwaltet den cm-basierten Längen- und Stückzahl-Selector für Ketten-Produkte.
 * Sendet Bestellungen via AJAX an /cart/add.js mit Menge = Länge × Stücke.
 */
(function () {
  'use strict';

  const SELECTORS = {
    container: '[data-chain-config]',
    variant: '[data-chain-variant]',
    length: '[data-chain-length]',
    pieces: '[data-chain-pieces]',
    totalLength: '[data-chain-total-length]',
    totalPrice: '[data-chain-total-price]',
    cutInfo: '[data-chain-cut-info]',
    submit: '[data-chain-add]',
    submitLabel: '[data-chain-add-label]',
    spinner: '[data-chain-spinner]',
    error: '[data-chain-error]'
  };

  const INIT_FLAG = 'chainConfigBound';

  // ---- Locale & currency ----
  const getCurrency = () => {
    try { return window.Shopify?.currency?.active || 'EUR'; }
    catch { return 'EUR'; }
  };

  const getLocale = () => document.documentElement.lang || 'de-DE';

  const fmtCurrency = (amount) => {
    try {
      return new Intl.NumberFormat(getLocale(), {
        style: 'currency',
        currency: getCurrency()
      }).format(amount);
    } catch {
      return amount.toFixed(2) + ' €';
    }
  };

  const cartRoot = () => {
    try { return window.Shopify?.routes?.root || '/'; }
    catch { return '/'; }
  };

  // ---- Cart drawer integration ----
  const notifyCartChange = () => {
    ['cart:refresh', 'cart:change', 'shopify:cart:update']
      .forEach(name => document.dispatchEvent(new CustomEvent(name, { bubbles: true })));
  };

  function openCartDrawer() {
  // Erst Cart neu laden (damit der Drawer den frischen Inhalt zeigt)
  fetch(cartRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // Events feuern, die Prestige für Counter/Notification nutzt
      var refreshEvents = ['cart:refresh', 'cart:change', 'cart:refresh:complete', 'cart:item-added'];
      for (var i = 0; i < refreshEvents.length; i++) {
        document.dispatchEvent(new CustomEvent(refreshEvents[i], {
          bubbles: true,
          detail: { cart: cart }
        }));
      }

      // Drawer öffnen: erst Custom-Element, dann Trigger-Button
      var drawer = document.querySelector('cart-drawer, [is="cart-drawer"], quick-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      // Fallback 1: Cart-Toggle programmatisch klicken
      var toggle = document.querySelector(
        '[data-action="open-cart"], ' +
        '[data-cart-drawer-toggle], ' +
        'cart-drawer-button, ' +
        'header a[href$="/cart"]'
      );
      if (toggle) {
        toggle.click();
        return;
      }

      // Fallback 2: Open-Events feuern (für Themes, die darauf hören)
      var openEvents = ['cart:open', 'cart-drawer:open', 'theme:cart:open', 'dialog:open'];
      for (var j = 0; j < openEvents.length; j++) {
        document.dispatchEvent(new CustomEvent(openEvents[j], { bubbles: true }));
      }
    })
    .catch(function (e) {
      console.warn('[chain-config] Cart refresh after add failed', e);
    });
}

  // ---- Init a single configurator ----
  const initConfig = (root) => {
    if (root.dataset[INIT_FLAG] === 'true') return;
    root.dataset[INIT_FLAG] = 'true';

    const variantInputs = root.querySelectorAll(SELECTORS.variant);
    const lengthInput   = root.querySelector(SELECTORS.length);
    const piecesInput   = root.querySelector(SELECTORS.pieces);
    const totalLengthEl = root.querySelector(SELECTORS.totalLength);
    const totalPriceEl  = root.querySelector(SELECTORS.totalPrice);
    const cutInfoEl     = root.querySelector(SELECTORS.cutInfo);
    const submitBtn     = root.querySelector(SELECTORS.submit);
    const submitLabel   = root.querySelector(SELECTORS.submitLabel);
    const spinnerEl     = root.querySelector(SELECTORS.spinner);
    const errorEl       = root.querySelector(SELECTORS.error);

    if (!lengthInput || !piecesInput || !submitBtn) {
      console.warn('[chain-config] Missing required elements in', root);
      return;
    }

    const getSelectedVariant = () => {
      // Single hidden input (only one variant)
      if (variantInputs.length === 1 && variantInputs[0].type === 'hidden') {
        return variantInputs[0];
      }
      // Radio buttons
      return Array.from(variantInputs).find(v => v.checked) || null;
    };

    const readInt = (el, fallback) => {
      const v = parseInt(el.value, 10);
      return Number.isFinite(v) ? v : fallback;
    };

    const showError = (msg) => {
      if (!errorEl) return;
      if (msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    };

    const update = () => {
      const variant = getSelectedVariant();
      const length = readInt(lengthInput, 0);
      const pieces = readInt(piecesInput, 1);
      const totalCm = length * pieces;

      if (cutInfoEl) {
        cutInfoEl.textContent = (length > 0 && pieces > 0)
          ? `${pieces} × ${length} cm`
          : '—';
      }

      if (totalLengthEl) {
        totalLengthEl.textContent = totalCm > 0 ? totalCm : '—';
      }

      if (totalPriceEl) {
        if (variant && totalCm > 0) {
          const pricePerCm = parseFloat(variant.dataset.price);
          totalPriceEl.textContent = Number.isFinite(pricePerCm)
            ? fmtCurrency(pricePerCm * totalCm)
            : '—';
        } else {
          totalPriceEl.textContent = '—';
        }
      }

      showError(null);
    };

    const validate = () => {
      const variant = getSelectedVariant();
      if (!variant) return 'Please select a thickness.';
      if (variant.dataset.available !== 'true') return 'This thickness is not available.';

      const length = readInt(lengthInput, 0);
      const minLen = parseInt(lengthInput.min, 10) || 0;
      const maxLen = parseInt(lengthInput.max, 10) || Number.MAX_SAFE_INTEGER;
      const step   = parseInt(lengthInput.step, 10) || 1;

      if (length < minLen) return `Minimum length is ${minLen} cm.`;
      if (length > maxLen) return `Maximum length is ${maxLen} cm.`;
      if (step > 1 && (length - minLen) % step !== 0) {
        return `Length must be in ${step} cm steps.`;
      }

      const pieces = readInt(piecesInput, 0);
      const minP   = parseInt(piecesInput.min, 10) || 1;
      const maxP   = parseInt(piecesInput.max, 10) || Number.MAX_SAFE_INTEGER;

      if (pieces < minP) return `Please order at least ${minP} chain(s).`;
      if (pieces > maxP) return `Maximum ${maxP} chain(s) per order.`;

      const totalCm = length * pieces;
      const inv = parseInt(variant.dataset.inventory, 10);
      // -1 = inventory not tracked, 0 = out of stock
      if (inv === 0) return 'This thickness is currently out of stock.';
      if (inv > 0 && totalCm > inv) {
        return `Only ${inv} cm in stock (requested: ${totalCm} cm).`;
      }

      return null;
    };

    const setLoading = (loading) => {
      submitBtn.disabled = loading;
      if (spinnerEl) spinnerEl.hidden = !loading;
      if (submitLabel) submitLabel.style.opacity = loading ? '0.4' : '';
    };

    const submit = async () => {
      const err = validate();
      if (err) { showError(err); return; }

      const variant = getSelectedVariant();
      const length  = readInt(lengthInput, 0);
      const pieces  = readInt(piecesInput, 1);
      const totalCm = length * pieces;
      const cutInfo = `${pieces} × ${length} cm`;

      setLoading(true);
      showError(null);

      try {
        const res = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variant.value),
              quantity: totalCm,
              properties: {
                'Cut': cutInfo,
                '_einzellaenge_cm': String(length),
                '_stueckzahl': String(pieces)
              }
            }]
          })
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Failed to add to cart.');
        }

        notifyCartChange();
        openCartDrawer();
      } catch (e) {
        console.error('[chain-config] Add to cart failed', e);
        showError(e.message || 'Error adding to cart.');
      } finally {
        setLoading(false);
      }
    };

    // ---- Event bindings ----
    [lengthInput, piecesInput].forEach(el => {
      el.addEventListener('input', update);
      el.addEventListener('change', update);
    });

    variantInputs.forEach(v => v.addEventListener('change', update));

    submitBtn.addEventListener('click', submit);

    // Initial render
    update();
  };

  const initAll = () => {
    document.querySelectorAll(SELECTORS.container).forEach(initConfig);
  };

  // ---- Bootstrapping ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor section reload
  document.addEventListener('shopify:section:load', initAll);

  // Re-init after variant change or product rerender (Prestige events)
  ['variant:change', 'product:rerender', 'shopify:section:reorder']
    .forEach(name => document.addEventListener(name, () => setTimeout(initAll, 50)));
})();